import axios from "axios";

// PATHS
const RA_DETAIL = `/network/ra/details`;
const SEND_VOID = '/network/ra';

const fetchRaDetail = async (req: any) => {
    const response = await axios.post(RA_DETAIL, req);
    return response.data;
}

const sendVoid = async (req: any) => {
    const response = await axios.post(SEND_VOID, req);
    return response.data;
}

export {
    fetchRaDetail,
    sendVoid
}
